import type {ReactNode} from 'react'

import {type PreviewQueryContextValue, PreviewQueryProvider} from '../../contexts/PreviewQueryContext'
import type {SavedViewIssuesRenderer} from '../../types'
import NewViewExperience from '../preview/NewViewExperience'

type RepositoryViewNewPreviewProps = {
  owner: string
  repo: string
  query: string
  previewQueryContextValue: PreviewQueryContextValue
  IssuesRenderer?: SavedViewIssuesRenderer
  preview?: (list: ReactNode) => ReactNode
}

export function RepositoryViewNewPreview({
  owner,
  repo,
  query,
  previewQueryContextValue,
  IssuesRenderer,
  preview,
}: RepositoryViewNewPreviewProps) {
  if (!query) {
    return <NewViewExperience />
  }

  const list = IssuesRenderer ? <IssuesRenderer owner={owner} repo={repo} query={query} preheatEnabled={false} /> : null

  return <PreviewQueryProvider value={previewQueryContextValue}>{preview ? preview(list) : list}</PreviewQueryProvider>
}
